module.exports = __webpack_public_path__ + "img/shareimg.d9196d97.png";